import axios from 'axios'
import { readCookies } from 'logic/auth'
import { refreshTokenMiddleware, checkForExpiredToken } from 'api/middlewares'

const BASE_URL = (import.meta.env.VITE_WA_MESSENGER_API_URL || 'http://localhost:3003') + '/v1'

refreshTokenMiddleware(axios)
checkForExpiredToken(axios)

const request = async function (req: any) {
	try {
		const response = await axios(req)
		return response
	} catch (e: any) {
		if (e.response) {
			const {
				status,
				data: { error_message, ...rest },
			} = e.response
			const err = { status, errorMessage: error_message || 'Failed to perform request, please try again.', ...rest }
			throw err
		} else {
			const errObject = e.toJSON()
			const err = { status: errObject.code, errorMessage: errObject.message, isNetworkError: true }
			throw err
		}
	}
}

function getDefaultHeaders() {
	return {
		'Content-type': 'application/json',
		'X-SMSLEOPARD-TOKEN': window.localStorage.getItem('x-smsleopard-token') || readCookies().auth_token || '',
		'X-SMSLEOPARD-ACCOUNT-ID': window.localStorage.getItem('x-smsleopard-account-id') || readCookies().account_id || '',
		'Accept-Language': window.localStorage.getItem('i18nextLng') || readCookies().preferred_language || '',
	}
}

type RequestParameters = {
	params?: {}
	url: string
	headers?: {}
	data?: {}
}

class Request {
	static get({ params = {}, url, headers }: RequestParameters): Promise<any> {
		return request({
			method: 'GET',
			url: BASE_URL + url,
			params,
			headers: headers || getDefaultHeaders(),
		})
	}

	static post({ data = {}, params = {}, headers = {}, url }: RequestParameters): Promise<any> {
		return request({
			method: 'POST',
			url: BASE_URL + url,
			data,
			params,
			headers: { ...getDefaultHeaders(), ...headers },
		})
	}

	static put({ data = {}, params = {}, url, headers }: RequestParameters): Promise<any> {
		return request({
			method: 'PUT',
			url: BASE_URL + url,
			data,
			params,
			headers: headers || getDefaultHeaders(),
		})
	}

	static patch({ data = {}, params = {}, url, headers }: RequestParameters): Promise<any> {
		return request({
			method: 'PATCH',
			url: BASE_URL + url,
			data,
			params,
			headers: headers || getDefaultHeaders(),
		})
	}

	static delete({ params = {}, data = {}, url, headers }: RequestParameters): Promise<any> {
		return request({
			method: 'DELETE',
			url: BASE_URL + url,
			data,
			params,
			headers: headers || getDefaultHeaders(),
		})
	}

	static filedownload({ url, params = {}, headers }: RequestParameters): Promise<any> {
		return request({
			url: BASE_URL + url,
			method: 'GET',
			responseType: 'blob',
			params,
			headers: headers || getDefaultHeaders(),
		})
	}

	static externalFileDownload({ url }: { url: string }): Promise<any> {
		return request({
			url: url,
			method: 'GET',
			responseType: 'blob',
		})
	}
}

export default Request
